/* tslint:disable */
/* eslint-disable */
/**
 * Telematics backend API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface RawDataPointStateActivityModel
 */
export interface RawDataPointStateActivityModel {
    /**
     * 
     * @type {string}
     * @memberof RawDataPointStateActivityModel
     */
    type: RawDataPointStateActivityModelTypeEnum;
    /**
     * 
     * @type {Date}
     * @memberof RawDataPointStateActivityModel
     */
    time: Date;
    /**
     * 
     * @type {string}
     * @memberof RawDataPointStateActivityModel
     */
    subtype: RawDataPointStateActivityModelSubtypeEnum;
    /**
     * 
     * @type {boolean}
     * @memberof RawDataPointStateActivityModel
     */
    on: boolean;
}

export function RawDataPointStateActivityModelFromJSON(json: any): RawDataPointStateActivityModel {
    return RawDataPointStateActivityModelFromJSONTyped(json, false);
}

export function RawDataPointStateActivityModelFromJSONTyped(json: any, ignoreDiscriminator: boolean): RawDataPointStateActivityModel {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'type': json['type'],
        'time': (new Date(json['time'])),
        'subtype': json['subtype'],
        'on': json['on'],
    };
}

export function RawDataPointStateActivityModelToJSON(value?: RawDataPointStateActivityModel | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'type': value.type,
        'time': (value.time.toISOString()),
        'subtype': value.subtype,
        'on': value.on,
    };
}

/**
* @export
* @enum {string}
*/
export enum RawDataPointStateActivityModelTypeEnum {
    State = 'state'
}
/**
* @export
* @enum {string}
*/
export enum RawDataPointStateActivityModelSubtypeEnum {
    Activity = 'activity'
}


